"use client";

import { c as _c } from "react/compiler-runtime";
import { ProxyMode } from "../UserPageProxy";
import { useState } from "react";
import dynamic from "next/dynamic";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import type { ApiProfileProxy } from "@/generated/models/ApiProfileProxy";
import ProxyListItem from "./ProxyListItem";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
export enum ProfileProxyListType {
  ALL = "ALL",
  RECEIVED = "RECEIVED",
  GRANTED = "GRANTED",
}
const ProxyListFilters = dynamic(() => import("./filters/ProxyListFilters"), {
  ssr: false
});
export default function ProxyList(t0) {
  const $ = _c(24);
  const {
    onModeChange,
    receivedProfileProxies,
    grantedProfileProxies,
    isSelf,
    profile,
    loading
  } = t0;
  const [proxyType, setProxyType] = useState(ProfileProxyListType.ALL);
  let t1;
  if ($[0] !== proxyType) {
    t1 = <ProxyListFilters selected={proxyType} setSelected={setProxyType} />;
    $[0] = proxyType;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isSelf || $[3] !== onModeChange) {
    t2 = isSelf && <CommonAnimationOpacity><PrimaryButton loading={false} disabled={false} onClicked={() => onModeChange(ProxyMode.CREATE)}><svg className="tw-w-5 tw-h-5 -tw-ml-1" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><span>Assign Proxy</span></PrimaryButton></CommonAnimationOpacity>;
    $[2] = isSelf;
    $[3] = onModeChange;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="tw-mt-4 sm:tw-mt-6 tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-x-4">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isSelf || $[9] !== loading || $[10] !== profile || $[11] !== proxyType || $[12] !== receivedProfileProxies) {
    t4 = [ProfileProxyListType.ALL, ProfileProxyListType.RECEIVED].includes(proxyType) && <div><p className="tw-mb-0 tw-flex-auto tw-font-semibold tw-text-iron-50 tw-text-lg">Received proxies</p><div className="tw-space-y-8">{receivedProfileProxies.length ? receivedProfileProxies.map(profileProxy => <ProxyListItem key={profileProxy.id} profileProxy={profileProxy} isSelf={isSelf} profile={profile} />) : <div className="tw-py-4 tw-text-sm tw-italic tw-text-iron-500">{loading ? "Loading proxies..." : "No received proxies"}</div>}</div></div>;
    $[8] = isSelf;
    $[9] = loading;
    $[10] = profile;
    $[11] = proxyType;
    $[12] = receivedProfileProxies;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== grantedProfileProxies || $[15] !== isSelf || $[16] !== loading || $[17] !== profile || $[18] !== proxyType) {
    t5 = [ProfileProxyListType.ALL, ProfileProxyListType.GRANTED].includes(proxyType) && <div><p className="tw-mb-0 tw-flex-auto tw-font-semibold tw-text-iron-50 tw-text-lg">Granted proxies</p><div className="tw-space-y-8">{grantedProfileProxies.length ? grantedProfileProxies.map(profileProxy_0 => <ProxyListItem key={profileProxy_0.id} profileProxy={profileProxy_0} isSelf={isSelf} profile={profile} />) : <div className="tw-py-4 tw-text-sm tw-italic tw-text-iron-500">{loading ? "Loading proxies..." : "No granted proxies"}</div>}</div></div>;
    $[14] = grantedProfileProxies;
    $[15] = isSelf;
    $[16] = loading;
    $[17] = profile;
    $[18] = proxyType;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t3 || $[21] !== t4 || $[22] !== t5) {
    t6 = <div className="tailwind-scope tw-space-y-6">{t3}{t4}{t5}</div>;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
}